interface MiniChartProps {
  type: string;
  color?: string;
  w?: number;
  h?: number;
}

// ─── Mini Chart ───
function MiniChart({ type, color = "#6366f1", w = 130, h = 44 }: MiniChartProps) {
  const colors = ["#6366f1", "#f59e0b", "#10b981"];
  
  if (type === "stacked_bar") {
    const bars = [
      { a: 20, b: 12, c: 7 },
      { a: 16, b: 16, c: 9 },
      { a: 23, b: 9, c: 11 },
      { a: 12, b: 20, c: 5 }
    ];
    return (
      <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`}>
        {bars.map((b, i) => {
          const x = 6 + i * (w - 12) / 4;
          const bw = (w - 24) / 4;
          let y = h - 4;
          return (
            <g key={i}>
              <rect 
                x={x} 
                y={y - b.a} 
                width={bw} 
                height={b.a} 
                rx={1} 
                fill={color} 
                opacity={.85}
              />
              <rect 
                x={x} 
                y={y - b.a - b.b} 
                width={bw} 
                height={b.b} 
                fill={colors[1]} 
                opacity={.7}
              />
              <rect 
                x={x} 
                y={y - b.a - b.b - b.c} 
                width={bw} 
                height={b.c} 
                rx={1} 
                fill={colors[2]} 
                opacity={.6}
              />
            </g>
          );
        })}
      </svg>
    );
  }
  
  if (type === "line") {
    const pts = [
      [4, 30],
      [w * .25, 18],
      [w * .5, 25],
      [w * .75, 10],
      [w - 4, 16]
    ];
    const d = pts.map((p, i) => `${i ? 'L' : 'M'}${p[0]},${p[1]}`).join(' ');
    return (
      <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`}>
        <path 
          d={d} 
          fill="none" 
          stroke={color} 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
        {pts.map((p, i) => (
          <circle key={i} cx={p[0]} cy={p[1]} r="2" fill={color} />
        ))}
      </svg>
    );
  }
  
  // Table type
  return (
    <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`}>
      <rect 
        x="2" 
        y="2" 
        width={w - 4} 
        height="10" 
        rx="2" 
        fill={color} 
        opacity=".12"
      />
      {[0, 1, 2].map(r => (
        <g key={r}>
          <line 
            x1="2" 
            y1={16 + r * 9} 
            x2={w - 2} 
            y2={16 + r * 9} 
            stroke="#2a2a33" 
            strokeWidth=".5"
          />
          <rect 
            x="5" 
            y={18 + r * 9} 
            width={20 + r * 6} 
            height="3.5" 
            rx="1" 
            fill="#5c5c6a" 
            opacity=".2"
          />
          <rect 
            x={w * .45} 
            y={18 + r * 9} 
            width={12 + r * 4} 
            height="3.5" 
            rx="1" 
            fill={color} 
            opacity=".2"
          />
        </g>
      ))}
    </svg>
  );
}

export default MiniChart;
